/*

XML Loader
--------------------------

Map the XML tree directly to a D3 tree, without any modifications.
Elements are displayed as tree nodes and the attributes are shown
in the tooltips.

*/
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Parser as XmlParser } from "xml2js/lib/parser";
export function typesafeXMLParse(str) {
    var result;
    var parser = new XmlParser({
        explicitRoot: false,
        explicitChildren: true,
        preserveChildrenOrder: true,
        // Don't merge attributes. XML attributes will be stored in node["$"]
        mergeAttrs: false,
    });
    parser.parseString(str, function (err, parsed) {
        if (err instanceof Error) {
            throw new Error("XML parse failed with '" + err.message + "'.");
        }
        else if (err) {
            throw new Error("XML parse failed.");
        }
        else {
            result = parsed;
        }
    });
    return result;
}
// Convert JS objects as returned by xml2js parser to tree description format
function convertXML(xml) {
    var e_1, _a, e_2, _b;
    var _c, _d;
    var tag = xml["#name"];
    var text = xml._;
    var properties = new Map();
    if (text)
        properties.set("~text", text);
    if (xml.$) {
        try {
            for (var _e = __values(Object.getOwnPropertyNames((_c = xml.$) !== null && _c !== void 0 ? _c : {})), _f = _e.next(); !_f.done; _f = _e.next()) {
                var key = _f.value;
                properties.set(key, xml.$[key]);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    var children = [];
    try {
        for (var _g = __values((_d = xml.$$) !== null && _d !== void 0 ? _d : []), _h = _g.next(); !_h.done; _h = _g.next()) {
            var child = _h.value;
            children.push(convertXML(child));
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return {
        name: tag,
        properties: properties,
        children: children,
    };
}
export function loadXml(graphString) {
    var xml = typesafeXMLParse(graphString);
    return { root: convertXML(xml) };
}
